import React from 'react';
import {
 Card, CardContent
} from 'shared/components/ui/card';
import {
 useDataBuilderV2
} from '../DataBuilderV2Context';

const DashboardWelcomeBanner: React.FC = () => {
    const {
 appFullName
} = useDataBuilderV2();

    return (
        <Card className="bg-slate-800 text-white">
            <CardContent className="p-6">
                <h1 className="text-2xl font-bold">Welcome to {appFullName || 'your app'}</h1>
                <p className="mt-1">
                    Manage your data schemas, connections, workflows, and more from the Data Builder dashboard.
                </p>
            </CardContent>
        </Card>
    );
};

export default DashboardWelcomeBanner;
